import { gql } from '../../__generated__/gql'

export const SONG_REQUEST_ENTRY_FIELDS_FRAGMENT = gql(`
  fragment songRequestEntryFields on SongRequestEntry {
    id
    entryId
    title
    album
    artist
    votesCount
    votedByUser
    song {
      id
    }
  }
`)
